export const testAccounts = [
  {
    id: "1",
    email: "test@podcast.com",
    password: "test123",
    name: "Test User",
    avatar: "/images/avatars/default.jpg",
    subscriptions: ["1", "3", "8"],
    favorites: ["1-1", "3-1", "8-2"],
    listening: {
      currentPodcast: "1",
      currentEpisode: "1-1",
      progress: 1230
    }
  },
  {
    id: "2",
    email: "demo@podcast.com",
    password: "demo123",
    name: "Demo User",
    avatar: "/images/avatars/demo.jpg",
    subscriptions: ["2", "4", "5", "10"],
    favorites: ["2-1", "4-3", "5-1"],
    listening: {
      currentPodcast: "4",
      currentEpisode: "4-1",
      progress: 540
    }
  }
];

export const defaultTestAccount = {
  email: "test@podcast.com",
  password: "test123"
};

export default testAccounts;
